export default __webpack_public_path__ + "static/media/partner-monkey-league.ac590a27.png";